import type { AppRouteRecordRaw } from '@/router/types'

export const appStoreRoutes: AppRouteRecordRaw[] = [
  {
    path: 'appStore',
    name: 'AppStore',
    component: () => import('@/views/systemManage/appStore/index.vue'),
    meta: { title: '应用商城' }
  }
]
